import Group from "@midland-industries/Components/Group";
import BestSellingItemsCard from "@midland-industries/Components/HomePage/BestSellingItemsCard";
import NewsletterCard from "@midland-industries/Components/HomePage/NewsletterCard";
import SavingsCard from "@midland-industries/Components/HomePage/SavingsCard";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";

const HomePageCards: React.FC = () => {
    return (
        <>
            <div
                style={{
                    height: 188,
                    width: "100%",
                    left: 0,
                    position: "absolute",
                    marginTop: "-188px",
                    zIndex: 2,
                    background: `linear-gradient(180deg, rgba(248, 249, 250, 0.00) 13.67%, ${colors.accent} 100%)`,
                }}
            />
            <Group
                justify="space-between"
                style={{
                    zIndex: 3,
                    marginTop: "-188px",
                }}
            >
                <BestSellingItemsCard />
                <SavingsCard />
                <NewsletterCard />
            </Group>
        </>
    );
};

export default HomePageCards;
